import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import WidgetIcon from './WidgetIcon';
import Background from './Background';
import { emphasizedTitle, radiusStyle } from '../../common/presentation';
import { t, widgetTitle, visible, safeUrl, linkAttrs } from '../../common/utils';
export default class WidgetCard extends Component {
  view() {
    const widget = this.attrs.widget;
    const definition = app.diyHomepage.get(widget.type);
    if (!definition?.component || widget.enabled === false || !visible(widget.audience)) return null;
    if (definition.isAvailable && !definition.isAvailable(widget)) return null;
    const standalone = ['banner', 'fof'].includes(widget.type);
    const url = safeUrl(widget.linkUrl);
    const emphasized = emphasizedTitle(widget);
    return m('section', {
      className: 'DiyHome-widget DiyHome-widget--' + widget.type + (standalone ? ' DiyHome-widget--standalone' : '') + (emphasized ? ' DiyHome-widget--emphasized' : ' DiyHome-widget--fofTitles'),
      style: {
        ...radiusStyle(),
        ...(widget.loadingHeight ? {
          '--diy-home-loading-height': widget.loadingHeight + 'px'
        } : {})
      },
      'data-home-widget': widget.id,
      'aria-label': widgetTitle(widget)
    }, [widget.type !== 'fof' && widget.showTitle !== false && m('header.DiyHome-widgetHeader', [m('div.DiyHome-heading', [m('div.FofWidgets-Widget-title', [widget.showIcon !== false && m(WidgetIcon, {
      icon: widget.icon || definition.icon,
      image: widget.iconImage,
      className: 'FofWidgets-Widget-title-icon DiyHome-headingIcon'
    }), m('span.FofWidgets-Widget-title-label', widgetTitle(widget))]), widget.subtitle && m('div.FofWidgets-Widget-title-desc.DiyHome-subtitle', widget.subtitle)]), url && m(Link, {
      ...linkAttrs(url),
      className: 'DiyHome-more'
    }, [widget.linkLabel || t('forum.view_all'), m(Icon, {
      name: 'fas fa-arrow-right'
    })])]), standalone ? m(definition.component, {
      widget,
      settings: widget.settings || {}
    }) : m('div.DiyHome-widgetContent', {
      className: widget.background?.mode && widget.background.mode !== 'theme' ? 'DiyHome-widgetContent--custom' : ''
    }, [m(Background, {
      background: widget.background
    }), m('div.DiyHome-surfaceForeground', m(definition.component, {
      widget,
      settings: widget.settings || {}
    }))])]);
  }
}
flarum.reg.add('edgeinfinity-diy-homepage', 'forum/components/WidgetCard', WidgetCard);